<template>
  <v-container fluid class="trainings-page">
    <portal to="toolbar">
      <v-toolbar-title>Training Subchapters</v-toolbar-title>
    </portal>
    <v-row>
      <v-col
        :order="previewOrder"
        cols="6"
        v-show="isQuestionPreviewVissible"
      >
        <question-item-preview
          :itemModel="previewItemModel"
          title="Preview"
          @deleteQuestion="deleteQuestion"
        />
      </v-col>
      <v-col
        :order="chaptersOrder"
        cols="6"
        v-show="showChaptersColumn"
      >
        <chapters ref="chapters" />
      </v-col>
      <v-col
        :order="questionsOrder"
        cols="6"
        v-show="showQuestionsColumn"
      >
        <questions
          ref="questions"
          v-show="!isQuestionCreatingVissible"
          @onItemDelete="onQuestionDelete"
        />
        <question-item
          :editMode="editMode"
          :isVisible="isQuestionCreatingVissible"
          :itemModel="editItemModel"
          :layout="preselectLayout"
          title="Add Question"
          v-show="isQuestionCreatingVissible"
          @onItemClose="onQuestionClose"
          @questionCreated="onQuestionCreate"
          @questionUpdated="onQuestionUpdate"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    isQuestionCreatingVissible: false,
    isQuestionPreviewVissible: false,
    previewItemModel: null,
    previewPosition: null,
    editMode: false,
    editItemModel: null,
    preselectLayout: null,
  }),
  computed: {
    isPreviewLeft() {
      return this.isQuestionPreviewVissible && this.previewPosition === 'left';
    },
    isPreviewRight() {
      return this.isQuestionPreviewVissible && this.previewPosition === 'right';
    },
    showChaptersColumn() {
      return !this.isQuestionPreviewVissible || this.isPreviewRight;
    },
    showQuestionsColumn() {
      return !this.isQuestionPreviewVissible || this.isPreviewLeft;
    },
    previewOrder() {
      return this.isPreviewLeft ? 1 : 2;
    },
    chaptersOrder() {
      return this.isPreviewLeft ? 3 : 1;
    },
    questionsOrder() {
      return this.isPreviewRight ? 3 : 2;
    },
  },

  methods: {
    deleteQuestion() {
      this.$refs.chapters.loadData();
      this.$refs.questions.loadData();
    },
    onQuestionCreate() {
      this.$refs.questions.loadData();
    },
    async onQuestionUpdate(updatedQuestion) {
      const actualPage = await this.$refs.questions.getQuestionPage(updatedQuestion.id);
      const pageToReload = !actualPage ? 1 : actualPage < updatedQuestion.page ? actualPage : updatedQuestion.page;
      await this.$refs.questions.mergeUpdatedQuestionPage(pageToReload ? pageToReload : actualPage);
      this.$refs.chapters.loadData();
    },
    onQuestionDelete() {
      this.$refs.chapters.loadData();
    },
    toggleQuestionPreview(position = 'right', item = {}, isVisible = false) {
      this.isQuestionPreviewVissible = isVisible;
      this.previewPosition = position;
      this.previewItemModel = item;
    },
    showQuestionEdit(item = {}) {
      this.isQuestionCreatingVissible = true;
      this.editItemModel = item;
      this.editMode = true;
      if (this.previewItemModel) {
        this.previewItemModel = null;
        this.isQuestionPreviewVissible = false;
      }
    },
    onQuestionClose() {
      this.isQuestionCreatingVissible = false;
      this.editItemModel = null;
      this.editMode = false;
    },
    toggleQuestionCreate(isVisible, layout) {
      const layoutQuery = Array.isArray(layout) ? layout[0] : layout
      this.preselectLayout = layoutQuery;
      this.isQuestionCreatingVissible = isVisible;
    },
  },
  components: {
    chapters: () => import("./components/Chapters.vue"),
    questions: () => import("./components/TrainingsQuestions.vue"),
    questionItem: () => import("@/app/exercise/components/question/QuestionItem.vue"),
    questionItemPreview: () => import("@/app/exercise/components/question/QuestionItemPreview.vue"),
  },
  provide: function() {
    return {
      toggleQuestionPreview: this.toggleQuestionPreview,
      toggleQuestionCreate: this.toggleQuestionCreate,
      showItemEdit: this.showQuestionEdit,
    }
  },
};
</script>
<style lang="scss" scoped>
.trainings-page::v-deep {
  .v-card {
    .card-header {
      height: 64px;
    }
    .body {
      &.inner-scroll {
        overflow: auto;
        display: flex;
        flex-direction: column;
      }
      &.no-footer {
        max-height: calc(100vh - 177px);
      }
    }
  }
}
</style>
